(function () {
  function start() {
    var header = document.querySelector('.header-section');
    if (!header) {
      var hc0 = document.getElementById('header-component');
      if (hc0) header = hc0.closest('.shopify-section');
    }
    if (!header) return;

    var headerComponent =
      header.querySelector('#header-component') ||
      header.querySelector('header-component') ||
      document.getElementById('header-component');

    if (headerComponent) {
      headerComponent.removeAttribute('sticky');
      headerComponent.removeAttribute('data-sticky-state');
      headerComponent.removeAttribute('data-scroll-direction');
    }

    header.style.removeProperty('top');
    header.style.removeProperty('transform');
    header.style.removeProperty('pointer-events');

    // Hero is section class "hero-wrapper", with .hero inside
    var heroFirst = !!document.querySelector(
      'main > .shopify-section:first-of-type.hero-wrapper,' +
        'main > .shopify-section:first-of-type.hero,' +
        'main > .shopify-section:first-of-type .hero'
    );

    var TOP = 50;
    var DELTA = 4;
    var lastY = -1;
    var hidden = false;
    var fadeSolidPending = false;

    function scrollY() {
      var wrap = document.querySelector('.page-wrapper');
      return Math.max(
        wrap ? wrap.scrollTop || 0 : 0,
        window.scrollY || window.pageYOffset || 0,
        (document.scrollingElement && document.scrollingElement.scrollTop) || 0,
        (document.documentElement && document.documentElement.scrollTop) || 0,
        (document.body && document.body.scrollTop) || 0,
        0
      );
    }

    function menuOpen() {
      return !!(
        header.querySelector('details.menu-drawer-container[open]') ||
        header.querySelector('dialog[open]')
      );
    }

    function measure() {
      if (hidden) return;

      var h = 0;
      if (headerComponent) {
        h = Math.max(h, headerComponent.getBoundingClientRect().height);
      }
      var rows = header.querySelectorAll('.header__row');
      var rowsH = 0;
      for (var i = 0; i < rows.length; i++) {
        rowsH += rows[i].getBoundingClientRect().height;
      }
      h = Math.max(h, rowsH, header.getBoundingClientRect().height, header.scrollHeight || 0);

      if (h < 40) h = 80;
      if (h > 400) h = 400;

      h = Math.ceil(h);
      document.documentElement.style.setProperty('--header-h', h + 'px');
      header.style.setProperty('--header-hide-y', h + 24 + 'px');
    }

    function setHidden(next) {
      if (hidden === next) return;
      var wasHidden = hidden;
      hidden = next;
      header.classList.toggle('is-hidden', next);

      // Mid-page reveal: paint transparent first, then fade to solid (CSS transition)
      if (wasHidden && !next && heroFirst && scrollY() > TOP) {
        fadeSolidPending = true;
        header.classList.add('is-transparent');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            fadeSolidPending = false;
            if (!hidden && scrollY() > TOP) {
              header.classList.remove('is-transparent');
            }
          });
        });
      }
    }

    function syncTransparent(atTop) {
      // Transparent at top, and stay transparent while sliding away (no white flash).
      // Mid-page when shown again = solid white (faded in via setHidden).
      if (fadeSolidPending) return;
      header.classList.toggle('is-transparent', heroFirst && (atTop || hidden));
    }

    function update() {
      var y = scrollY();
      var atTop = y <= TOP;
      var headerH =
        parseFloat(
          getComputedStyle(document.documentElement).getPropertyValue('--header-h')
        ) || 80;

      // Hide/show only when scroll position actually changed
      if (lastY < 0 || y !== lastY) {
        var delta = lastY < 0 ? 0 : y - lastY;

        if (atTop || menuOpen()) {
          setHidden(false);
        } else if (delta > DELTA) {
          setHidden(true);
        } else if (delta < -DELTA) {
          setHidden(false);
        } else if (y > headerH && !hidden && delta >= 0) {
          setHidden(true);
        }

        lastY = y;
      }

      // Always sync transparent (also on first paint / refresh)
      syncTransparent(atTop);
    }

    var wrap = document.querySelector('.page-wrapper');
    if (wrap) wrap.addEventListener('scroll', update, { passive: true });
    window.addEventListener('scroll', update, { passive: true, capture: true });
    document.addEventListener('scroll', update, { passive: true });
    window.addEventListener('wheel', update, { passive: true });
    window.addEventListener('touchmove', update, { passive: true });
    setInterval(update, 50);

    if (headerComponent) {
      new MutationObserver(function () {
        if (headerComponent.hasAttribute('sticky')) headerComponent.removeAttribute('sticky');
        if (headerComponent.hasAttribute('data-sticky-state')) {
          headerComponent.removeAttribute('data-sticky-state');
        }
      }).observe(headerComponent, {
        attributes: true,
        attributeFilter: ['sticky', 'data-sticky-state']
      });
    }

    new ResizeObserver(measure).observe(header);
    measure();

    // Immediate transparent on hero homepage (before first scroll)
    if (heroFirst) header.classList.add('is-transparent');
    lastY = scrollY();
    update();

    // Anti-flash: geef de controle door van de CSS boot-state naar JS.
    // Pas ná het zetten van de juiste transparant/solid-staat, en één frame
    // later, zodat die staat al geschilderd is vóórdat de transitions weer
    // aan gaan → geen witte fade bij het laden (ook niet bij mid-page refresh).
    requestAnimationFrame(function () {
      document.body.classList.add('header-js');
    });
  }

  if (document.readyState !== 'loading') start();
  else document.addEventListener('DOMContentLoaded', start, { once: true });
})();

